// /invite/<key>: after sign-in, ask the API whether this key is ours and usable.
import React, { useEffect, useState } from "react";
import { api } from "../lib/api.js";
import { forgetInviteKey, navigate } from "../lib/router.js";
import RepRegister from "./RepRegister.jsx";
import Done from "./Done.jsx";
import NotInvited from "./NotInvited.jsx";

export default function Invite({ inviteKey, account }) {
  const [state, setState] = useState({ loading: true });
  const [done, setDone] = useState(null);

  useEffect(() => {
    let alive = true;
    api(`/invitations/${encodeURIComponent(inviteKey)}`)
      .then(inv => alive && setState({ invitation: inv }))
      .catch(err => alive && setState({ error: err.message }));
    return () => { alive = false; };
  }, [inviteKey]);

  if (state.loading) return <p className="lead">Checking your invitation…</p>;
  if (state.error) return <NotInvited reason={state.error} onTryAgain={() => { forgetInviteKey(); navigate("/"); }} />;
  if (done) return <Done registration={done} onRestart={() => { forgetInviteKey(); navigate("/"); }} />;
  return <RepRegister account={account} invitation={state.invitation} inviteKey={inviteKey} onDone={(reg) => { forgetInviteKey(); setDone(reg); }} />;
}
